export const HI_MAMI_CLICK_ID_PARAM = "click_id";
export const HI_MAMI_CLICK_ID_COOKIE = "click_id";

const HI_MAMI_COOKIE_TTL_DAYS = 7;
const IL_SECOND_LEVEL_SUFFIXES = new Set([
  "co.il",
  "org.il",
  "net.il",
  "ac.il",
  "gov.il",
]);

const isIpAddress = (hostname: string) =>
  /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname);

const normalizeCookieDomain = (domain: string) =>
  domain.startsWith(".") ? domain : `.${domain}`;

const resolveCookieDomain = (hostname: string) => {
  if (!hostname || hostname === "localhost" || isIpAddress(hostname)) {
    return undefined;
  }

  const parts = hostname.split(".");
  if (parts.length <= 2) {
    return normalizeCookieDomain(hostname);
  }

  const suffix = parts.slice(-2).join(".");
  if (IL_SECOND_LEVEL_SUFFIXES.has(suffix) && parts.length >= 3) {
    return normalizeCookieDomain(parts.slice(-3).join("."));
  }

  return normalizeCookieDomain(parts.slice(-2).join("."));
};

export const setHiMamiClickIdCookie = (clickId: string) => {
  if (!clickId || typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  const maxAge = HI_MAMI_COOKIE_TTL_DAYS * 24 * 60 * 60;
  const explicitCookieDomain = process.env.HI_MAMI_COOKIE_DOMAIN?.trim();
  const cookieDomain = explicitCookieDomain
    ? normalizeCookieDomain(explicitCookieDomain)
    : resolveCookieDomain(window.location.hostname);

  const cookieParts = [
    `${HI_MAMI_CLICK_ID_COOKIE}=${encodeURIComponent(clickId)}`,
    "path=/",
    `max-age=${maxAge}`,
    "secure",
    "samesite=Lax",
  ];

  if (cookieDomain) {
    cookieParts.push(`domain=${cookieDomain}`);
  }

  document.cookie = cookieParts.join("; ");
};

export const getCookieValue = (cookieName: string) => {
  if (typeof document === "undefined") {
    return "";
  }

  const prefix = `${cookieName}=`;
  const cookie = document.cookie
    .split(";")
    .map((item) => item.trim())
    .find((item) => item.startsWith(prefix));

  if (!cookie) {
    return "";
  }

  return decodeURIComponent(cookie.slice(prefix.length));
};

export const getHiMamiClickIdFromCookie = () =>
  getCookieValue(HI_MAMI_CLICK_ID_COOKIE);

export const normalizeCoupon = (coupon?: string | null) => (coupon ?? "").trim();

export const isHiMamiCoupon = (coupon?: string | null) =>
  /mami/i.test(normalizeCoupon(coupon));
